module.exports = __webpack_public_path__ + "img/molly.1d472213.jpg";